// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!../../node_modules/vue-accessible-color-picker/dist/ColorPicker.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vue3-icon-picker[data-v-0835c117] {
        cursor: pointer;
        /* font-size:30px; */
}
button.select-icon[data-v-0835c117] {
        padding: 20px;
        border-radius: 5px;
        background-color: #70b2dc;
        font-size: 22px;
        cursor: pointer;
}
.icon-picker-wrap ul[data-v-0835c117] {
        list-style: none;
        margin: 0;
        padding: 0;
        display: inline-flex;
}
.icon-picker-wrap ul li[data-v-0835c117] {
            border: 2px solid #ddd;
            line-height: 1;
            font-size: 20px;
            cursor: pointer;
            padding: 5px;
}
.icon-picker-wrap ul li i[data-v-0835c117] {
                font-size: 68px;
                line-height: 1;
                margin: 0;
}
.icon-picker-wrap ul li[data-v-0835c117]:nth-child(2) {
                border-left: 0;
}

    /*
 */
.aim-close[data-v-0835c117] {
        opacity: 0;
        visibility: hidden;
        transition: all 0.4s ease-in-out;
}
.aim-open[data-v-0835c117] {
        opacity: 1;
        visibility: visible;
        transition: all 0.4s ease-in-out;
}
.aim-modal[data-v-0835c117] {
        position: fixed;
        height: 100%;
        width: 100%;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 9999;
        -webkit-user-select: none;
           -moz-user-select: none;
                user-select: none;
        display: flex;
        align-items: center;
}
.aim-modal .aim-modal--content[data-v-0835c117] {
            position: absolute;
            border-radius: 3px;
            box-shadow: 2px 8px 23px 3px rgba(0, 0, 0, 0.2);
            overflow: hidden;
            font-family: Roboto, Arial, Helvetica, Verdana, sans-serif;
            background-color: #f1f3f5;
            width: 100%;
            margin: auto;
            left: 0;
            right: 0;
}


        /* Header */
.aim-modal .aim-modal--header[data-v-0835c117] {
            padding: 15px 15px;
            background-color: #fff;
            box-shadow: 0 0 8px rgb(0 0 0 / 10%);
            position: relative;
            z-index: 1;
            font-size: 15px;
            color: #495157;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: space-between;
}
.aim-modal--header-logo-title[data-v-0835c117] {
        padding-top: 2px;
        line-height: 1;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
}
.aim-modal--header-close-btn[data-v-0835c117] {
        cursor: pointer;
}
.aim-modal--header-close-btn i[data-v-0835c117] {
            font-size: 22px;
}

    /* body */
.aim-modal--body[data-v-0835c117] {
        font-size: 12px;
        line-height: 1.5;
        box-sizing: border-box;
        padding: 0;
        height: 700px;
        display: flex;
        min-height: 50px;
        max-height: 85vh;
        overflow: auto;
}


    /* Sidebar Tabs */
.aim-modal--sidebar[data-v-0835c117] {
        padding:10px;
        flex-shrink: 0;
        width: 25%;
        background-color: hsla(0,0%,100%,.3);
}
.aim-modal--sidebar-tabs[data-v-0835c117] {
        margin-top: 30px;
}
.aim-modal--sidebar-tab-item[data-v-0835c117] {
        padding: 15px 0 15px 45px;
        font-size: 14px;
        color: #6d7882;
        text-align: left;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        text-transform: capitalize;
}
.aim-modal--sidebar-tab-item i[data-v-0835c117] {
            font-size: 20px;
            padding-right: 15px;
            color: #a4afb7;
}
.aim-modal--sidebar-tab-item.aesthetic-active[data-v-0835c117] {
            background-color: #fff;
            box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}
.aim-modal--sidebar-tab-item.aesthetic-active[data-v-0835c117]:after {
                content: "";
                position: absolute;
                height: 100%;
                width: 5px;
                top: 0;
                left: 0;
                background-color: #71d7f7;
}
.aim-modal--sidebar-tab-item.aesthetic-active i[data-v-0835c117] {
                color: #71d7f7;
}




    /* Preview wrapper */
.aim-modal--icon-preview-wrap[data-v-0835c117] {
        display: flex;
        flex-direction: column;
        padding: 30px 80px 0;
        width: 75%;
}
.aim-modal--icon-preview-inner[data-v-0835c117] {
        overflow: auto;
        margin: 25px -15px 0;
        padding: 0 15px 15px;
}
.aim-modal--icon-preview[data-v-0835c117] {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-gap: 20px;
        margin: 20px 0;
}


    /* search filter */
.aim-modal--icon-search[data-v-0835c117] {
        position: relative;
}
.aim-modal--icon-search input[data-v-0835c117] {
            width: calc( 100% - 30px);
            padding: 8px 15px;
            background-color: #fff;
            border: none;
}
.aim-modal--icon-search input[data-v-0835c117]::-moz-placeholder {
                font-style: italic;
}
.aim-modal--icon-search input[data-v-0835c117]::placeholder {
                font-style: italic;
}
.aim-modal--icon-search i[data-v-0835c117] {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 15px;
}

    /* Icon Item */
.aim-icon-item[data-v-0835c117] {
        position: relative;
        padding: 10px;
        background-color: #fff;
        box-shadow: 0 1px 12px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.3s;
        overflow: hidden;
}
.aim-icon-item[data-v-0835c117]:hover {
            box-shadow: 0 1px 14px rgba(0, 0, 0, 0.16);
}
.aim-icon-item.aesthetic-selected[data-v-0835c117] {
            box-shadow: 0 1px 12px rgba(0, 0, 0, 0.05), 0 0 0 3px #71d7f7;
}
.aim-icon-item-inner[data-v-0835c117] {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1px;
}
.aim-icon-item-inner i[data-v-0835c117],
        .aim-icon-item__icon[data-v-0835c117] {
            font-size: 25px;
            color: #6d7882;
}
.aim-icon-item-name[data-v-0835c117] {
        color: #c2cbd2;
        font-size: 11px;
        padding: 13px 20px 0;
        max-width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-transform: capitalize;
}


    /* Footer */
.aim-modal .aim-modal--footer[data-v-0835c117] {
        border-top: 1px solid #e6e9ec;
        text-align: center;
        background-color: #fff;
        border: none;
        display: none;
        justify-content: flex-end;
        padding: 5px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
        position: relative;
        display: flex;
}
.aim-modal--footer button.aim-insert-icon-button[data-v-0835c117] {
        padding: 10px 35px;
        color: #fff;
        font-size: 15px;
        background-color: #39b54a;
        border: none;
        cursor: pointer;
        outline: 0;
}
.aim-modal--footer button.aim-close-icon-button[data-v-0835c117] {
        padding: 10px 35px;
        color: #fff;
        font-size: 15px;
        background-color: gray;
        border: none;
        cursor: pointer;
        outline: 0;
}
.aim-modal .aim-modal--footer .aesthetic-button[data-v-0835c117] {
        height: 40px;
        margin-left: 5px;
}
.aim-modal .aim-modal--footer .aesthetic-button-success[data-v-0835c117] {
        padding: 12px 36px;
        color: #fff;
        width: initial;
        font-size: 15px;
}
.aim-modal .aim-modal--footer .aesthetic-button-success[data-v-0835c117]:hover {
            background-color: #39b54a;
}

    /* preview sidebar */
.aim-sidebar-preview[data-v-0835c117] {
        position: absolute;
        bottom: 50px;
        width: 300px;
}
.aim-sidebar-preview .aim-icon-item[data-v-0835c117] {
            height: 200px;
}
.aim-sidebar-preview .aim-icon-item-inner i[data-v-0835c117] {
            padding-top: 0px;
            /*font-size: 120px;*/
}
.aim-sidebar-preview .aim-icon-item-name[data-v-0835c117] {
            padding-top: 0px;
            font-size: 20px;
            color: #444;
            text-transform: lowercase;
}


    /* Responsive css */
@media (max-width: 1439px) {
.aim-modal .aim-modal--content[data-v-0835c117] {
            max-width: 990px;
}
}
@media (min-width: 1440px) {
.aim-modal .aim-modal--content[data-v-0835c117] {
            max-width: 1200px;
}
}
@media (max-width: 1439px) {
.aim-modal--icon-preview-wrap[data-v-0835c117] {
            padding: 30px 50px 0;
}
}
@media (max-width: 479px) {
.aim-modal--icon-preview-wrap[data-v-0835c117] {
            width: 100%;
}
}
@media (max-width: 1439px) {
.aim-modal--icon-preview[data-v-0835c117] {
            grid-template-columns: repeat(6, 1fr);
}
}
@media (max-width: 1024px) {
.aim-modal--icon-preview[data-v-0835c117] {
            grid-template-columns: repeat(5, 1fr);
}
}
@media (max-width: 767px) {
.aim-modal--icon-preview[data-v-0835c117] {
            grid-template-columns: repeat(4, 1fr);
}
}
@media (max-width: 479px) {
.aim-modal--icon-preview[data-v-0835c117] {
            grid-template-columns: repeat(3, 1fr);
}
}
@media (max-width: 479px) {
.aim-modal--sidebar[data-v-0835c117] {
            display: none;
}
}
@media (max-width: 1439px) {
.aim-modal--sidebar-tab-item[data-v-0835c117] {
            padding: 15px 15px 15px 25px;
            font-size: 11px;
}
.aim-modal--sidebar-tab-item i[data-v-0835c117] {
                font-size: 15px;
}
}
@media (max-width: 1024px) {
.aim-modal--sidebar-tab-item i[data-v-0835c117] {
            display: none;
}
}

`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
